import React, { Component, useEffect } from 'react';
import {StyleSheet, Text, View, Animated, SafeAreaView, Pressable, FlatList, Easing, Dimensions, Image, ScrollView, AppState, TextInput, Platform} from 'react-native';

import { Checkbox } from 'react-native-paper';
import { Ionicons } from 'react-native-vector-icons';
import { Overlay } from 'react-native-elements';

import Constants from 'expo-constants';

import GameData from './GameData';
import ActionRow from './ActionRow';
import ThreatCounter from './ThreatCounter';
import Inventory from './Inventory';
import ProgressBar from './ProgressBar';
import CodeAnim from './CodeAnim';

import * as Font from 'expo-font';

import TaskImages from './Images';

const fps = 2;
const fpsDuration = 1000/fps;
const fpsPecent = 1/fps;
const MYEPSILON = 0.0001;

const windowWidth = Dimensions.get('window').width;
const windowHeight = Dimensions.get('window').height;

class HomeScreen extends Component {
  constructor(props) {
    super(props);

    this.state = {
        refresh: false,
        refreshActions: false,
        totalThreat: GameData.threat,
        totalPower: GameData.getStartingPower(),
        enableRepeat: false,
        repeatLast: false,
        enableRestart: false,
        autoRestart: false,
        enablelocations: true, //GameData.enableLocations,
        fontLoaded: false,
        showOverlay: false,
        overlayTitle: "",
        overlayText: "",
        overlayImage: null,
        lvlups: [],
		gameLoaded: false,
		appState: "",
		//nextAppState: "",
    }

	this.threatText = 0;
    this.threat = GameData.threat;
    this.power = GameData.getStartingPower();
    this.interval = null;
	this.threatRef = React.createRef();
	this.disableCloseOverlay = false;
	
	GameData.homeScreen = this;

  }
  
  async refresh() {
	  await this.setState({refresh: !this.state.refresh});
  }

  async componentDidMount () {
    await this._loadAssets();
    //this.threatTextAnim.addListener(({value}) => this._value = value);
  
	await GameData.loadGame();
	this.setState({gameLoaded: true, enableRepeat: GameData.enableRepeat, repeatLast: GameData.repeat, enableRestart: GameData.enableRestart, autoRestart: GameData.restart});
	console.log("Game Loaded");
	this.closeOverlay();
	await this.checkAwayTime();
	
	this.setState({appState: AppState.currentState});
	this.appStateListener = AppState.addEventListener(
      'change',
      async nextAppState => {
		  //console.log(this.state.appState, nextAppState);
		  if (this.state.appState === 'active' && (nextAppState === "background" || nextAppState === "inactive")) {
			await GameData.saveAwayTime();
		  }
		  if ((this.state.appState === "background" || this.state.appState === "inactive") && nextAppState === 'active') {
			  await this.checkAwayTime();
		  }
        //console.log('Next AppState is: ', nextAppState);
		this.setState({appState: nextAppState});
      },
    );
  }
  
  async checkAwayTime() {
	await GameData.getAwayTime();
	  let diffTime = Math.floor(Date.now()/1000) - GameData.awayTime;
	  //console.log(diffTime);
	  if ((Platform.OS == 'ios' || Platform.OS == 'android') && diffTime > 30 && GameData.code.length > 0) {
			this.forceFinish();
			this.resetLife();
		  if (GameData.restart) {
			  
			let lifeTime = GameData.estimateLifeTime();
			let livesLived = Math.min(Math.floor(diffTime / lifeTime), 10);
			//console.log("Lives lived: " + livesLived);
			
			for (let i = 0; i < livesLived; i++) {
				GameData.liveLife();
			}
			//this.forceFinish();
			let awayText = "While you were away you lived ";
			if (livesLived == 10) {
				awayText = awayText + "10(max) lives.";
			}
			else {
				awayText = awayText + livesLived + " lives.";
			}
			this.setState({
				showOverlay: true,
				overlayTitle: "Away Lives",
				overlayText: awayText,
				overlayImage: null,
			  });
			  //this.forceFinish();
			//this.closeOverlay();
		  }
	  }
  }
  
  async componentWillUnmount () {
	  this.appStateListener?.remove();
  }
  
  async _loadAssets () {
    await Font.loadAsync({
      'Alegreya-Regular': require('../assets/fonts/Alegreya-Regular.otf'),
    })
    console.log('your fonts loaded!')
    this.setState({fontLoaded: true})
  }

  threatPercentage = 0;
  riseIndex = 0;
  tasks = [];
  //threatTextAnim = new Animated.Value(0);
  slideAnim = new Animated.Value(0);
  
  //threatAnim = new Animated.Value(0);
  lvlAnim = new Animated.Value(0);
  schemesEnabled = false;
  lifeRunning = false;
  clearActions = false;
  endRun = false;
  editSchemes = true;
  
    getItemLayout = (data, index) => (
		{ length: 40, offset: 40 * index, index }
	  )

  getThreat() {
    //return this.threatTextAnim._value;
	return this.threatText;
	//return this.threatInterpolate.__getValue();
  }
  
  getPower() {
	return this.power;
  }

  canContinue() {
    if (this.power > this.threat) {
      return true;
    }
    return false;
  }

  completeScheme(scheme, schemeInfo, percent) {
    let completionInfo = GameData.complete(scheme, percent);

    this.power = GameData.getPower();

    if (scheme.completion.threat) {
      this.threat = Math.max(this.threat + scheme.completion.threat, 0);
      //this.threatTextAnim.setValue(this.threat)
      //this.threatAnim.setValue(this.threat / this.power);
	  this.threatRef.current.set(Math.min(this.threat / this.power, 1));
	  
	  clearInterval(this.threatTextInterval);
	  clearTimeout(this.threatTime);
	  this.threatText = this.threat;
    }

    //this.setState({totalPower: this.power, totalThreat: this.threat});

    /*
    if (completion.power) {
      this.power += completion.power;
      setTimeout(function(){
        this.setState({totalPower: this.power});
      }.bind(this), time);
    }
    */

    let lvlups = this.state.lvlups;
    for (let i = 0; i < completionInfo.length; i++) {
      lvlups.push(completionInfo[i]);
      setTimeout(function(){
        this.foo = this.state.lvlups;
        this.foo.splice(0,1);
        this.setState({lvlups: this.foo});
      }.bind(this),2000);
      }
    //this.setState({totalPower: this.power, totalThreat: this.threat, lvlups: lvlups});
    let overlayInfo = GameData.checkForMessage();
    if (overlayInfo) {
      if (overlayInfo.tutorial1) {
        this.endRun = true;
        this.clearActions = true;
        if (this.clearActions) {
          this.clearActions = false;
          GameData.code = [];
          GameData.resetIndex();
          this.tasks = [];
        }
      }
      if (overlayInfo.tutorial2) {
        this.endRun = true;
        GameData.enableRepeat = true;
        GameData.enableRestart = true;
        this.setState({enableRepeat: true, enableRestart: true});
      }
      if (overlayInfo.tutorial3) {
        this.endRun = true;
        GameData.enableLocations = true;
        this.setState({enableLocations: true});
      }
      if (overlayInfo.tutorial4) {
        this.endRun = true;
      }
      if (overlayInfo.tutorial5) {
        this.endRun = true;
      }
	  if (overlayInfo.gameEnd) {
		  //this.endRun = true;
		  this.disableCloseOverlay = true;
		  GameData.beatGame();
		  //GameData.gameBeaten = true;
		  this.setState({
			overlayShowEnd: true,
			//autoRestart: false,
		  })
	  }
      this.setState({
        showOverlay: true,
        overlayTitle: overlayInfo.title,
        overlayText: overlayInfo.text,
        overlayImage: overlayInfo.image,
		//autoRestart: false,
      })
      if (this.canContinue()) {
        this.continueScheme = schemeInfo;
      }
      else {
        this.continueScheme = null;
      }
      return true;
    }
    return false;
    //this.setState({refreshActions: !this.state.refreshActions});
  }

  slide() {
    if (this.lifeRunning) {
      return;
    }
    this.schemesEnabled = !this.schemesEnabled;
    if (this.schemesEnabled) {
      this.slideOut();
    }
    else {
      this.slideIn();
    }
  }
  
	resetLife() {
		this.editSchemes = true;
		GameData.resetInventory();
		GameData.form = 'baby';
		this.unreadyTasks();
		this.wipeTasks();
		this.updateRest(0);
		this.riseIndex = 0;
		this.threatPercentage = 0;
		//this.threatAnim.setValue(0);
		if (this.threatRef.current) {
			this.threatRef.current.set(0);
		}
		//this.threatTextAnim.setValue(0);
		this.setState({totalThreat: 0, totalPower: GameData.getStartingPower()});    
	}
	
	loadRefresh() {
		//await this.refresh();
		
		GameData.resetInventory();
		GameData.form = 'baby';
		//this.unreadyTasks();
		//this.wipeTasks();
		this.tasks = [];
		this.riseIndex = 0;
		this.threatPercentage = 0;
		//this.threatAnim.setValue(0);
		this.threatRef.current.set(0);
		//this.threatTextAnim.setValue(0);
		this.slideAnim.setValue(0);
		this.schemesEnabled = false;
		
		this.setState({refresh: !this.state.refresh, totalThreat: 0, totalPower: GameData.getStartingPower()});	
		this.closeOverlay();
	}

  slideOut = () => {
    
	this.editSchemes = true;
	
    GameData.resetInventory();
	GameData.form = 'baby';
    this.unreadyTasks();
    this.wipeTasks();
	this.updateRest(0);
    this.riseIndex = 0;
    this.threatPercentage = 0;
    //this.threatAnim.setValue(0);
	this.threatRef.current.set(0);
    //this.threatTextAnim.setValue(0);
    this.setState({refresh: !this.state.refresh, totalThreat: 0, totalPower: GameData.getStartingPower()});
    
    Animated.timing(this.slideAnim, {
      toValue: 1,
      duration: 100,
      useNativeDriver: false,
    }).start();
	
	if (GameData.code.length > 0) {
		setTimeout(function(){
	        this.codeRef.scrollToIndex({index:Math.max(GameData.codeIndex-1, 0)});
		  }.bind(this),150);
	}
  }

  slideIn = () => {
    Animated.timing(this.slideAnim, {
      toValue: 0,
      duration: 100,
      useNativeDriver: false,
    }).start();
  }

  bottomInterpolate =
    this.slideAnim.interpolate({
      inputRange: [0, 1],
      outputRange: [40, 240]
    });

  capitalize(str){
    return str.charAt(0).toUpperCase() + str.slice(1);
  }

  showSchemeInfo(scheme) {
	  if (this.lifeRunning) {
		  return;
	  }
    let schemeText = scheme.description + "\n\n";
    schemeText += "Base Time: " + Math.round(scheme.time*100)/100 + " seconds\n"; //" / " + Math.round(GameData.getTime(scheme)*100)/100 + " seconds\n";
    //if (scheme.completion.map) {
      //schemeText += this.capitalize(scheme.completion.map) + " familiarity: " + Math.floor(GameData.getMapPercent(scheme.completion.map)*100) + "%\n";
    //}

    let keys = [];
	let keys2 = [];
	/*
    if (scheme.timeModifiers.map) {
      schemeText += "Familiarity modifiers: ";
      keys = Object.keys(scheme.timeModifiers.map);
      for (let i = 0; i < keys.length; i++) {
        //schemeText += this.capitalize(keys[i]) + " " + Math.round((1 - 1/scheme.timeModifiers.map[keys[i]])*100) + "% ";
		schemeText += this.capitalize(keys[i]) + " " + Math.round(scheme.timeModifiers.map[keys[i]]*100) + "% ";
      }
      schemeText += "\n";
    }
	*/

    if (scheme.timeModifiers.skill) {
      //schemeText += "Vice modifiers:";
	  schemeText += "Time modifiers:";
      keys = Object.keys(scheme.timeModifiers.skill);
      for (let i = 0; i < keys.length; i++) {
        schemeText += " " + this.capitalize(keys[i]) + " " + Math.floor(scheme.timeModifiers.skill[keys[i]]*100) + "% ";
      }
      schemeText += "\n";
    }
	
	if (scheme.timeModifiers.inventory) {
      schemeText += "Inventory modifiers:";
      keys = Object.keys(scheme.timeModifiers.inventory);
      for (let i = 0; i < keys.length; i++) {
        schemeText += " " + this.capitalize(keys[i]) + " " + scheme.timeModifiers.inventory[keys[i]][0] + "(" + Math.floor(scheme.timeModifiers.inventory[keys[i]][1]*100) + "%)"
      }
      schemeText += "\n";
    }
	
	if (scheme.completion.inventory) {
      schemeText += "Inventory:";
      keys = Object.keys(scheme.completion.inventory);
      for (let i = 0; i < keys.length; i++) {
        schemeText += " " + this.capitalize(keys[i]) + " ";
		if (scheme.outputModifiers) {
			let amount = scheme.completion.inventory[keys[i]][0]
			let mod = 0;
			if (scheme.outputModifiers.skill) {
				keys2 = Object.keys(scheme.outputModifiers.skill);
				for (let j = 0; j < keys2.length; j++) {
					mod += scheme.outputModifiers.skill[keys2[j]] * GameData.getSkillLvl(keys2[j]);
				}
				mod = Math.pow(mod, scheme.completion.inventory[keys[i]][2]);
			}
			amount += scheme.completion.inventory[keys[i]][1] * mod;
			schemeText += Math.floor(amount).toString();
			
			if (scheme.completion.inventory[keys[i]][0] == 0) {
				schemeText += " [ " + scheme.completion.inventory[keys[i]][1];
			}
			else {
				schemeText += " [ " + scheme.completion.inventory[keys[i]][0] + " + " + scheme.completion.inventory[keys[i]][1];
			}
			schemeText += " (";
			/*
			if (scheme.outputModifiers.map) {
				keys2 = Object.keys(scheme.outputModifiers.map);
				for (let j = 0; j < keys2.length; j++) {
					schemeText += "*" + this.capitalize(keys2[j]) + "(" + Math.round(scheme.outputModifiers.map[keys2[j]]*100) + "%)";
				}
			}
			*/
			if (scheme.outputModifiers.skill) {
				keys2 = Object.keys(scheme.outputModifiers.skill);
				for (let j = 0; j < keys2.length; j++) {
					if (j > 0) {
						schemeText += " + "; 
					}
					schemeText += this.capitalize(keys2[j]) + "*" + scheme.outputModifiers.skill[keys2[j]];
				}
			}
			schemeText += ")"
			if (scheme.completion.inventory[keys[i]][2] && scheme.completion.inventory[keys[i]][2] != 1) {
				schemeText += "**" + scheme.completion.inventory[keys[i]][2] + " ]";
			}
		}
		else {
			schemeText += " " + scheme.completion.inventory[keys[i]][0];
		}
      }
      schemeText += "\n";
    }
	
	if (scheme.completion.skill) {
      schemeText += "Exp:";
      keys = Object.keys(scheme.completion.skill);
      for (let i = 0; i < keys.length; i++) {
		  if (i > 0) {
			  schemeText += ","
		  }
        schemeText += " " + this.capitalize(keys[i]) + " " + scheme.completion.skill[keys[i]];
      }
      schemeText += "\n";
    }
	
	if (scheme.completion.threat) {
		schemeText += "Threat: " + scheme.completion.threat;
		schemeText += "\n";
	}

    this.setState({
      showOverlay: true,
      overlayTitle: scheme.name,
      overlayText: schemeText,
    });
  }
  
  updateRest(count) {
	  if (count < this.tasks.length) {
		  this.tasks[count].updateBarEstimate();
	  }
  }

  renderCode({item, index}) {
    return (
      <View style={styles.item}>
        <ActionRow task={item} ref={(element) => {
          if(element) {
           if (element.taskNumber > this.tasks.length) {
            this.tasks.push(element)
            }
            else {
              this.tasks[element.taskNumber-1] = element;
            }
          }
          }}
          taskCount={index}
          rise={this.rise.bind(this)}
          raiseThreat={this.raiseThreat.bind(this)}
          finish={this.finish.bind(this)}
          remove={this.removeScheme.bind(this)}
          complete={this.completeScheme.bind(this)}
          canContinue={this.canContinue.bind(this)}
		  setCodeIndex={this.setCodeIndex.bind(this)}
		  overlayInfo={this.showSchemeInfo.bind(this, item.action)}
		  updateRest={this.updateRest.bind(this)}
          >
      </ActionRow>
      </View>
    )
  }
  
  auditCode(startIndex, add) {
	  let codeIndex = GameData.codeIndex
	  GameData.codeIndex = startIndex;
	  for (let i = Math.max(startIndex, 0); i < GameData.code.length; i++) {
		 GameData.codeIndex = i;
		 if (!GameData.meetRequirments(GameData.code[i].action.requirements)) {
			  GameData.code.splice(i, 1);
			  this.tasks.splice(i, 1);
			  i = Math.max(i-2, 0);
			  continue;
         }
		 if (i+1 < GameData.code.length && GameData.code[i].action.name === GameData.code[i+1].action.name) {
			GameData.code[i].count += GameData.code[i+1].count;
			GameData.code.splice(i+1, 1);
			if (add) {
				this.tasks.splice(i, 1);
				this.tasks[Math.max(i-1, 0)].updateCount(GameData.code[i].count);						
			}
			else {
				this.tasks.splice(i+1, 1);
				this.tasks[i].updateCount(GameData.code[i].count);				
			}
			//this.tasks[i].setState({refresh: !this.tasks[i].state.refresh});
			i--;
			continue;
		 }
	  }
	  
		if (codeIndex > GameData.code.length) {
		  GameData.codeIndex = GameData.code.length;
		}
		else {
			GameData.codeIndex = codeIndex;
		}
		
		if (add) {
			startIndex = Math.max(startIndex - 1, 0)
		}
	
		for (let i = Math.max(startIndex, 0); i < this.tasks.length; i++) {
			if (add) {
				this.tasks[i].taskNumber = i+2;
			}
			else {
				this.tasks[i].taskNumber = i+1;
			}
		  this.tasks[i].setState({refresh: !this.tasks[i].state.refresh});
		}			
	  
	  setTimeout(function(){
        this.updateRest(0);
	  }.bind(this),100);	
	
	this.setState({refresh: !this.state.refresh});
  }

  removeScheme(schemeNumber) {
    GameData.code.splice(schemeNumber-1, 1);
	this.tasks.splice(schemeNumber-1, 1);
    if (schemeNumber <= GameData.codeIndex) {
      GameData.codeIndex -= 1;
	  //if(schemeNumber > GameData.codeIndex && schemeNumber > 1) {
		  //this.tasks[schemeNumber-2].setState({refresh: !this.tasks[schemeNumber-2].state.refresh});
	  //}
    }
	
	this.auditCode(schemeNumber-2, false);
	return;

    if (GameData.code.length > 1 && schemeNumber > 1 && schemeNumber-1 < GameData.code.length) {
      while (GameData.canIncremenet(GameData.code[schemeNumber-2].action) && GameData.code[schemeNumber-2].action.name === GameData.code[schemeNumber-1].action.name) {
        GameData.code[schemeNumber-2].count += GameData.code[schemeNumber-1].count;
        GameData.code.splice(schemeNumber-1, 1);
        this.tasks.splice(schemeNumber-1, 1);
        this.tasks[schemeNumber-2].updateCount(GameData.code[schemeNumber-2].count);
        if (schemeNumber <= GameData.codeIndex) {
          GameData.codeIndex -= 1;
        }
		if (schemeNumber-1 >= GameData.code.length) {
			break;
		}			
      }
    }

    this.tasks.splice(schemeNumber-1, 1);
	
      let tempIndex = GameData.codeIndex;
	  GameData.codeIndex = schemeNumber-1;
      while(GameData.codeIndex < GameData.code.length) {
        if (GameData.meetRequirments(GameData.code[GameData.codeIndex].action.requirements)) {
          GameData.codeIndex += 1;
        }
        else {
          GameData.code.splice(GameData.codeIndex, 1);
		  this.tasks.splice(GameData.codeIndex, 1);
		  if (GameData.codeIndex < tempIndex) {
			  tempIndex -= 1;
		  }
        }
      }
      GameData.codeIndex = tempIndex;
	  //if (GameData.codeIndex >= 1) {
	  if (GameData.codeIndex >= 1 && GameData.codeIndex <= this.tasks.length) {
		this.tasks[GameData.codeIndex-1].setState({refresh: !this.tasks[GameData.codeIndex-1].state.refresh});
	  }
	
    //this.setState({refresh: !this.state.refresh});
    for (let i = 0; i < this.tasks.length; i++) {
      this.tasks[i].taskNumber = i+1;
    }
	
	setTimeout(function(){
        this.updateRest(0);
	  }.bind(this),100);	
	
	this.setState({refresh: !this.state.refresh});

  }

  renderActions({ item }) {
    if(!GameData.meetRequirments(item.requirements) || GameData.meetDisable(item.disable)) {
      return;
    }
	/*
	GameData.codeIndex += 1;
	if(!GameData.meetRequirments(item.requirements) || GameData.meetDisable(item.disable)) {
		GameData.codeIndex -= 1;
      return;
    }
	GameData.codeIndex -= 1;
	*/

    let progressBar = null
	/*
    if (item.completion.map) {
      let progressPercent = GameData.mapCompletion[item.completion.map][0] / GameData.mapCompletion[item.completion.map][1] *100 + "%";
      progressBar = <Animated.View style={[styles.schemeProgress, {width:progressPercent}]}>
        </Animated.View>
    }
	*/

    return (
      <View style={styles.item}>
        <View style={styles.row}>
          <Pressable onPress={() => this.addAction(item)} onLongPress={() => this.showSchemeInfo(item)} style={styles.actionButton}>
            <Image style={styles.logo} source={TaskImages[item.image]} />
            <Text style={styles.actionText} adjustsFontSizeToFit={true} numberOfLines={1}> {item.name} </Text>
            <Image style={styles.logo} source={TaskImages[item.image]} />
          </Pressable>
        </View>
      </View>
    )
  }

  addAction = (action) => {
    //this.setState({refresh: !this.state.refresh});
    if (GameData.codeIndex < GameData.code.length && GameData.code[GameData.codeIndex].action.name == action.name) {
      this.tasks[GameData.codeIndex].increment();
    }
    else if (GameData.codeIndex != 0 && GameData.code[GameData.codeIndex-1].action.name == action.name) {
      this.tasks[GameData.codeIndex-1].increment();
    }
    else {
      //for (let i = GameData.codeIndex; i < this.tasks.length; i++) {
        //this.tasks[i].taskNumber = i+2;
      //}
      GameData.code = this.addAfter(GameData.code, GameData.codeIndex, {action: action, count: 1, timesDone: 0, id: GameData.getId()});
	  
	  GameData.codeIndex += 1;
	  
	  this.auditCode(GameData.codeIndex, true);
	  
	if (GameData.codeIndex == GameData.code.length) {
		setTimeout(function(){
	        //this.codeRef.scrollToIndex({index:Math.max(GameData.codeIndex-1, 0), viewOffset: 40});
			this.codeRef.scrollToEnd();
		  }.bind(this),100);
	}
	else if (GameData.codeIndex > 1) {
		setTimeout(function(){
	        this.codeRef.scrollToIndex({index:Math.max(GameData.codeIndex-2, 0)});
		  }.bind(this),100);		
	}	  
	  
	  return;

      const tempIndex = GameData.codeIndex;
      while(GameData.codeIndex < GameData.code.length) {
        if (GameData.meetRequirments(GameData.code[GameData.codeIndex].action.requirements)) {
          GameData.codeIndex += 1;
        }
        else {
          GameData.code.splice(GameData.codeIndex, 1);
		  
		  this.tasks.splice(GameData.codeIndex, 1);
		  
		  if (GameData.codeIndex < tempIndex) {
			  tempIndex -= 1;
		  }
        }
      }
      GameData.codeIndex = tempIndex;
	  
		for (let i = 0; i < this.tasks.length; i++) {
		  //this.tasks[i].taskNumber = i+1;
		}

	   for (let i = GameData.codeIndex-1; i < this.tasks.length; i++) {
		  this.tasks[i].taskNumber = i+2;
		}
		//this.updateRest(Math.max(GameData.codeIndex-1, 0));
      this.setState({refresh: !this.state.refresh});
	  
	  
	if (GameData.codeIndex == GameData.code.length) {
		setTimeout(function(){
	        //this.codeRef.scrollToIndex({index:Math.max(GameData.codeIndex-1, 0), viewOffset: 40});
			this.codeRef.scrollToEnd();
		  }.bind(this),100);
	}
	else if (GameData.codeIndex > 1) {
		setTimeout(function(){
	        this.codeRef.scrollToIndex({index:Math.max(GameData.codeIndex-2, 0)});
		  }.bind(this),100);		
	}

	setTimeout(function(){
        this.updateRest(0);
	  }.bind(this),100);		
		
    }
	
	
    //this.refreshTasks();
  }

  addAfter(array, index, newItem) {
    return [
        ...array.slice(0, index),
        newItem,
        ...array.slice(index)
        ];
    }
	
	stopRise() {
		if (this.lifeRunning) {
			//this.threatAnim.stopAnimation();
			this.threatRef.current.stop();
			//this.threatTextAnim.stopAnimation();
			this.tasks[this.riseIndex-1].stop();
			this.forceFinish();
		}
	}

  startRise() {
    if (this.tasks.length == 0) {
      return;
    }
    if (this.lifeRunning) {
      return;
    }
	
	this.editSchemes = false;

    this.schemesEnabled = false;
    this.slideAnim.setValue(0);
    //this.threatAnim.setValue(0);
	this.threatRef.current.set(0);
    //this.threatTextAnim.setValue(0);
    GameData.resetInventory();
	GameData.form = 'baby';
    GameData.wipeTimesDone();
	GameData.timePassed = 0;
    this.readyTasks();
    this.wipeTasks();
    this.riseIndex = 0;
    this.threatPercentage = 0;
    this.lifeRunning = true;
    GameData.lives += 1;
	GameData.totalLives += 1;
    this.threat = GameData.threat;
    this.power = GameData.getStartingPower();
    this.setState({totalThreat: this.threat, totalPower: this.power}, this.rise.bind(this, 0));
  }

  rise() {
	if (this.canContinue()) {
		if (this.riseIndex < this.tasks.length) {
			this.codeRef.scrollToIndex({index: this.riseIndex});
		  this.tasks[this.riseIndex].start();
		  
		  //if (this.tasks[this.riseIndex].props.task.action.animation) {
			//this.codeAnimRef.changeImage(this.tasks[this.riseIndex].props.task.action.animation);
		  //}
		  //else {
			  //this.codeAnimRef.changeImage(null);
		  //}
		  
		  this.riseIndex += 1;
		}
		else {
		  if (this.state.repeatLast) {
			if (GameData.canIncremenet(GameData.code[this.riseIndex-1].action)) {
			  this.tasks[this.riseIndex-1].restart();
			}
			else {
			   this.finish();
			}
		  }
		  else {
			this.finish();
		  }
		}
	}
	else {
		this.finish();
	}
  }

  raiseThreat(threat, time) {
    let newThreat = this.threat + threat;
    //this.threatAnim.setValue(Math.min(this.threat / this.power, 1));
	this.threatRef.current.set(Math.min(this.threat / this.power, 1));
	this.threatText = this.threat;
    this.threat = Math.min(newThreat, this.power);
    //this.setState({totalThreat: this.threat});
    this.threatPercentage = Math.min(newThreat / this.power, 1);

    if (1 - this.threatPercentage < MYEPSILON) {
      this.threat = this.power;
      //this.setState({totalThreat: this.threat});
      let extraThreat = (newThreat - this.power) / threat;
      if (extraThreat < MYEPSILON) {
        extraThreat = 0;
      }
      time *= 1-extraThreat;

	  /*
	  this.threatInterpolate =
		this.threatTextAnim.interpolate({
		  inputRange: [Math.min(this.threat / this.power, 1), this.threat],
		  outputRange: [this.threatText.toString(), this.threat.toString()],
		});
	  
      Animated.timing(this.threatTextAnim, {
        toValue: this.threat,
        easing: Easing.linear,
        duration: time,
        useNativeDriver: false,
      }).start();
	  */
	  
	  
	  let textIncrement = (this.threat - this.threatText) / time;
	  let fps = 1000/60
	  let prevTime = null;
	  clearInterval(this.threatTextInterval);
	  clearTimeout(this.threatTime);
	  this.threatTextInterval = setInterval(function() {
		  prevTime = prevTime ? prevTime : Date.now()
		  let diffTime = Date.now() - prevTime
			prevTime = Date.now();
			this.threatText += textIncrement * diffTime;
          }.bind(this), fps);
	  
	  this.threatTime = setTimeout(function() {
          clearInterval(this.threatTextInterval);
		  this.threatText = this.threat;
        }.bind(this), time );
		
      
	  /*
      Animated.timing(this.threatAnim, {
        toValue: this.threatPercentage,
        easing: Easing.linear,
        duration: time,
        useNativeDriver: false,
      }).start();
	  */
	  this.threatRef.current.start(this.threatPercentage, time);
      return {end: true, time: time};
    }
    //this.setState({totalThreat: newThreat});
	
		/*
	  this.threatInterpolate =
		this.threatTextAnim.interpolate({
		  inputRange: [Math.min(this.threat / this.power, 1), this.threat],
		  outputRange: [this.threatText.toString(), this.threat.toString()],
		});
	  
      Animated.timing(this.threatTextAnim, {
        toValue: this.threat,
        easing: Easing.linear,
        duration: time,
        useNativeDriver: false,
      }).start();
	  */
	  
	  let textIncrement = (this.threat - this.threatText) / time;
	  let fps = 1000/60
	  let prevTime = null;
	  clearInterval(this.threatTextInterval);
	  clearTimeout(this.threatTime);
	  this.threatTextInterval = setInterval(function() {
		  prevTime = prevTime ? prevTime : Date.now()
		  let diffTime = Date.now() - prevTime
			prevTime = Date.now();
			this.threatText += textIncrement * diffTime;
          }.bind(this), fps);
	  
	  this.threatTime = setTimeout(function() {
          clearInterval(this.threatTextInterval);
		  this.threatText = this.threat;
        }.bind(this), time );
	
	/*
    Animated.timing(this.threatAnim, {
      toValue: this.threatPercentage,
      easing: Easing.linear,
      duration: time,
      useNativeDriver: false,
    }).start();
	*/
	this.threatRef.current.start(this.threatPercentage, time);
    return {end: false, time: time};
  }

  readyTasks() {
    for (let i = 0; i < this.tasks.length; i++) {
      this.tasks[i].ready();
    }
  }

  unreadyTasks() {
    for (let i = 0; i < this.tasks.length; i++) {
      this.tasks[i].unready();
    }
  }

  wipeTasks() {
    for (let i = 0; i < this.tasks.length; i++) {
      this.tasks[i].refresh();
    }
  }

  refreshTasks() {
    for (let i = 0; i < this.tasks.length; i++) {
      this.tasks[i].setState({refresh: !this.tasks[i].refresh});
    }    
  }
  
  forceFinish() {
	  clearInterval(this.threatTextInterval);
	  clearTimeout(this.threatTime);
		GameData.saveGame();
		
		//if (this.codeAnimRef) {
		//this.codeAnimRef.changeImage(null);	
		//}
	  
	  this.continueScheme = null;
      this.lifeRunning = false;
	  this.setState({refresh: !this.state.refresh})
  }

  finish() {
	  	  clearInterval(this.threatTextInterval);
	  clearTimeout(this.threatTime);
	  GameData.saveGame();
	  
	  //if (this.codeAnimRef) {
		//this.codeAnimRef.changeImage(null);	
		//}
	  
    if (this.state.autoRestart) {
      this.lifeRunning = false;
      this.startRise();
    }
    else {
      this.continueScheme = null;
      this.lifeRunning = false;
	  setTimeout(function(){
        this.setState({refresh: !this.state.refresh});
      }.bind(this), 100);
	  //this.setState({refresh: !this.state.refresh});
    }
  }

	/*
  progressInterpolate =
    this.threatAnim.interpolate({
      inputRange: [0, 1],
      outputRange: ["0%", "100%"]
    });
	*/
	
	/*
  threatInterpolate =
    this.threatAnim.interpolate({
      inputRange: [0, 1],
      outputRange: ["0", "1"],
    });
	*/
	
	endGame() {
		this.disableCloseOverlay = false;
		
		this.setState({
			overlayShowEnd: false,
			showOverlay: true,
			overlayTitle: "Time of Death",
			overlayText: "I pick up my phylactery and feel the warmth of my soul. Death, Time has been restored. I look at Gavriel, and see a happy tear. What was once immortal man, is reduced to Dust.\n\n\n\nThanks for playing! I hope you enjoyed Lich Baby. If you wish you can still prestige in the options screen.",
			overlayImage: null,
			//autoRestart: false,
		  })
	}
	
	prestige() {
		this.disableCloseOverlay = false;
		GameData.prestige();
		this.tasks = [];
		//GameData.codeIndex = 0;
		this.setState({
			overlayShowEnd: false,
			showOverlay: true,
			overlayTitle: "Lich Baby",
			overlayText: "I hesitate for a moment, and that is all Gavriel needs to trigger the binding sigil I unwittingly stepped into. I am frozen. Gavriel takes my phylactery and leaves without a word.\n\n\n\nCongratz, you have prestiged! Try the game again but with the threat amount of all schemes increased. If you would still like to see the ending you can view it in the options screen.",
			overlayImage: null,
			//autoRestart: false,
		  })
	}

  closeOverlay() {
	if (this.disableCloseOverlay) {
		return;
	}
    if (this.endRun) {
	  //GameData.restart = false;
      this.setState({showOverlay: false});
      this.endRun = false;
      //this.forceFinish();
      this.finish();
	  return;
    }

    let overlayInfo = GameData.checkForMessage();
    if (overlayInfo) {
      this.setState({
        showOverlay: true,
        overlayTitle: overlayInfo.title,
        overlayText: overlayInfo.text,
		overlayImage: overlayInfo.image,
      });
    }
    else {
	  //GameData.restart = false;
      this.setState({showOverlay: false, overlayImage: null});
      if (this.continueScheme) {
        this.continueScheme.resume();
      }
      else if (this.lifeRunning) {
        this.finish();
      }
	  else {
		  GameData.saveGame();
	  }
    }
  }

	//<Image style={styles.lvllogo} source={TaskImages[item.image]} />
  renderlvls({ item }) {
    return (
      <View style={styles.lvlItem}>
        <View style={styles.lvlstart}>
          <Text style={styles.lvltext} adjustsFontSizeToFit={true}> {item.name}</Text>
        </View>
        <View style={styles.lvlend}>
          <Text style={styles.lvltext}>Leveled Up </Text>
          <Ionicons
            name="md-arrow-up-outline"
            size={25}
            color={"#000000"}
          />
        </View>
      </View>
    )
  };

  roundText(number) {
    if (Math.ceil(number) - number < MYEPSILON) {
      return Math.ceil(number);
    }
    return Math.floor(number);
  }

  renderInventory({item}) {
    //return <Text style={styles.inventory}>{item}: {GameData.inventory[item]}</Text>
	return <View>
		<Image style={styles.inventoryImage} source={TaskImages[item.toLowerCase()]} />;
		<Text style={styles.inventory}>: {GameData.inventory[item]}</Text>
	</View>
  }

  setCodeIndex(index) {
    if (!this.lifeRunning) {
      GameData.codeIndex = index;
    }
    this.setState({refresh: !this.state.refresh});
  }

  render() {
	  if (!this.state.fontLoaded || !this.state.gameLoaded) {
		  return null;
	  }
	  
    let overlayImage = null;
    if (this.state.overlayImage) {
      overlayImage = <Image style={styles.overlayImage} source={TaskImages[this.state.overlayImage]} />;
    }
    let repeat = null;
    let restart = null;
    if (this.state.enableRepeat) {
      repeat = <Pressable style={styles.repeat} onPress={() => {GameData.repeat = !GameData.repeat; this.setState({repeatLast: !this.state.repeatLast})}}>
            <Text style={styles.playText}>Repeat Last</Text>
            <View style={styles.checkbox}>
              <Checkbox status={this.state.repeatLast ? 'checked' : 'unchecked'} onPress={() => {GameData.repeat = !GameData.repeat; this.setState({repeatLast: !this.state.repeatLast})}}
              uncheckedColor='#f44336' color='#f44336'
              />
            </View>
          </Pressable>
    }
    if (this.state.enableRestart) {
      restart = <Pressable style={styles.repeat} onPress={() =>  {GameData.restart = !GameData.restart; this.setState({autoRestart: !this.state.autoRestart})}}>
            <Text style={styles.playText}>Auto Restart</Text>
            <View style={styles.checkbox}>
              <Checkbox status={this.state.autoRestart ? 'checked' : 'unchecked'} onPress={() => {GameData.restart = !GameData.restart; this.setState({autoRestart: !this.state.autoRestart})}}
              uncheckedColor='#f44336' color='#f44336'
              />
            </View>
          </Pressable>
    }

    let inventory = null;
    if (Object.keys(GameData.inventory).length > 0) {
      inventory = <View style={styles.threatInventory}>
          <FlatList
            contentContainerStyle={{paddingLeft: 10, paddingRight: 10}}
            //columnWrapperStyle={{ alignItems: "flex-start" }}
            numColumns={10}
            scrollEnabled={false}
            data={Object.keys(GameData.inventory)}
            renderItem={this.renderInventory.bind(this)}
          />
        </View>
    }

    /*
    let location = null;
    if (this.state.enablelocations) {
      location = <View style={styles.location}>
          <Pressable>
            <Ionicons
            name="md-arrow-back-outline"
            size={25}
            color={"#000000"}
          />
          </Pressable>
          <Text style={styles.locationText}>Graveyard</Text>
          <Pressable>
            <Ionicons
            name="md-arrow-forward-outline"
            size={25}
            color={"#000000"}
          />
          </Pressable>
      </View>
    }
    */

    let threatHightlight = styles.threatNoHighlight;
    if (GameData.codeIndex == 0 && this.editSchemes) {
      threatHightlight = styles.threatHighlight;
    }
	
	let editLife = null
	if (!this.lifeRunning && !this.editSchemes) {
		editLife = <Pressable style={styles.editAll} onPress={this.resetLife.bind(this)}/>;
	}

    //<Image style={styles.overlayBack} source={TaskImages.back} capInsets={{bottom: 125,left: 125,right: 125,top: 125,}}/>
    return (
      <View  style={styles.container}>
        <Overlay visible={this.state.showOverlay} onBackdropPress={this.closeOverlay.bind(this)} overlayStyle={styles.overlayStyle}>
          <Text style={styles.overlayTitle}>{this.state.overlayTitle}</Text>
          <Text style={styles.overlayText}>{this.state.overlayText}</Text>
          {overlayImage}
			  {!this.state.overlayShowEnd &&
          <Pressable onPress={this.closeOverlay.bind(this)}>
            <Text style={styles.overlayPress}>Close</Text>
          </Pressable>				  
			  }
			  {this.state.overlayShowEnd && GameData.prestigeAmount == 0 &&
		  <Pressable onPress={this.endGame.bind(this)}>
            <Text style={styles.overlayPress}>End It</Text>
          </Pressable>
			  }
		  {this.state.overlayShowEnd &&
		  <Pressable visible={this.state.gameEnd} onPress={this.prestige.bind(this)}>
            <Text style={styles.overlayPress}>Be Reborn</Text>
          </Pressable>
		  }
        </Overlay>
        <View style={styles.threat}>
          <Pressable style={threatHightlight} onPress={this.setCodeIndex.bind(this, 0)}>
          </Pressable>
          <View style={styles.threatTop}>
            <Text style={styles.threatTopLeft}>Threat</Text>
            <Text style={styles.threatTopRight}>Dread</Text>
          </View>
		  <ProgressBar style={styles.threatBar} ref={this.threatRef}/>
          <View style={styles.threatBottom}>
            <View style={styles.threatBottomLeft}>
			  <ThreatCounter update={this.getThreat.bind(this)}/>
            </View>
			<View style={styles.threatBottomLeft}>
              <ThreatCounter update={this.getPower.bind(this)}/>
            </View>
          </View>
        </View>
        <Inventory></Inventory>
        <View style={styles.body}>
          <View style={styles.topSide}>
              <FlatList  
				ref={(ref) => { this.codeRef = ref; }}
                scrollEnabled={true}
                data={GameData.code}
                renderItem={this.renderCode.bind(this)}
                keyExtractor={item => item.id}
				getItemLayout={this.getItemLayout}
              />
          </View>
          <View style={styles.lvlContainer}>
            <FlatList
              scrollEnabled={false}
              data={this.state.lvlups}
              renderItem={this.renderlvls.bind(this)}
            />
          </View>
		  {editLife}
          <Animated.View style={[styles.bottomSide, {height: this.bottomInterpolate}]}>
            <Pressable onPress={this.slide.bind(this)}>
              <Text style={styles.schemesTitle}>Schemes</Text>
            </Pressable>
            <FlatList
                scrollEnabled={true}
                data={GameData.actions}
                renderItem={this.renderActions.bind(this)}
              />
          </Animated.View>
        </View>
        <View style={styles.play}>
          {repeat}
          <Pressable onPress={this.startRise.bind(this)} onLongPress={this.stopRise.bind(this)}>
            <Text style={styles.playText}>Rise</Text>
            <Ionicons
              name="md-play-outline"
              size={20}
              color={'#f44336'}
            />
          </Pressable>
          {restart}
        </View>
      </View >
    )
  }
}

//<CodeAnim ref={(ref) => { this.codeAnimRef = ref; }}/>

const styles = StyleSheet.create({
  container: {
    //flexDirection: "row",
    flex: 1,
    backgroundColor: '#ffffff',
  },
  topSide: {
    backgroundColor: '#000000',
    flex: 1,
    width: '100%'
  },
  bottomSide: {
    width: '100%',
    backgroundColor: '#000000',
    borderTopWidth: 2,
    borderColor: '#ffffff',
  },
  schemesTitle: {
    height: 40,
    color: '#ffffff',
    fontSize: 24,
    textAlign: 'center',
    fontFamily: 'Alegreya-Regular',
    textDecorationLine: 'underline',
  },
  threat: {
    //paddingTop: Constants.statusBarHeight,
    //height: 60+Constants.statusBarHeight,
	//flex: 0.125,
	//height: 85,
    position: 'relative',
	width: '100%',
    borderBottomWidth: 2,
    borderColor: '#000000',
    backgroundColor: '#fff',
    alignItems: 'center',
  },
  threatHighlight: {
    position: 'absolute',
    left: 0,
    right: 0,
    //top: Constants.statusBarHeight,
	top: 0,
    bottom: 0,
    borderTopWidth: 4,
    borderBottomWidth: 4,
    borderColor: '#f44336',
    zIndex: 1,
  },
  threatNoHighlight: {
    position: 'absolute',
    left: 0,
    right: 0,
    //top: Constants.statusBarHeight,
	top: 0,
    bottom: 0,
    borderColor: '#f44336',
    zIndex: 1,
  },
  threatTop: {
    flexDirection: "row",
    justifyContent: 'space-between',
    width: "100%",
  },
  threatTopLeft: {
    paddingLeft: 5,
    color: '#000000',
    fontFamily: 'Alegreya-Regular',
    fontSize: 20,
  },
  threatTopRight: {
    paddingRight: 5,
    color: '#000000',
    fontFamily: 'Alegreya-Regular',
    fontSize: 20,
  },
  threatBar: {
    //top: Constants.statusBarHeight,
    top: 0,
	position: 'absolute',
    height: '100%',
	zIndex: -1,
    backgroundColor: '#f44336',
	//backgroundColor: '#a50113',
    left: 0,
  },
  threatBottom: {
    flexDirection: "row",
    justifyContent: 'space-between',
    width: "100%",
  },
  threatBottomLeft: {
    paddingLeft: 10,
    color: '#000000',
    fontFamily: 'Alegreya-Regular',
    fontSize: 20,
  },
  threatBottomRight: {
    paddingRight: 10,
    color: '#000000',
    fontFamily: 'Alegreya-Regular',
    fontSize: 20,
  },
  threatInventory: {
    borderBottomWidth: 2,
    width: '100%',
  },
  inventory: {
    fontSize: 16,
    flex: 1,
	textAlign: 'center',
    fontFamily: 'Alegreya-Regular',
  },
  play: {
    flexDirection: "row",
    height: 50,
    width: '100%',
    borderTopWidth: 2,
    borderColor: '#ffffff',
    backgroundColor:  '#000000',
    alignItems: 'center',
    justifyContent: 'space-around',
  },
  repeat: {
    alignItems: 'center',
  },
  body: {
    //flexDirection: "row",
    flex: 1,
  },
  item: {
    backgroundColor: '#fff',
    //borderTopWidth: 1,
    borderBottomWidth: 2,
    borderColor: '#000',
    height: 40,
    flexDirection: 'row',
    alignContent: 'center',
  },
  playText: {
    color: '#f44336',
    fontFamily: 'Alegreya-Regular',
    fontSize: 16,
  },
  otherText: {
    fontFamily: 'Alegreya-Regular',
    fontSize: 20,
  },
  actionButton: {
    flexDirection: 'row',
    alignItems: 'center',
    width: '100%',
    justifyContent: 'center',
  },
  actionText: {
    fontFamily: 'Alegreya-Regular',
    fontSize: 20,
    flex: 1,
    textAlign: 'center',
  },
  checkbox: {
    margin: -5,
  },
  logo: {
    margin: 5,
    alignContent: 'center',
    height: 25,
    width: 25,
  },
  overlayTitle: {
    fontFamily: 'Alegreya-Regular',
    color: '#ffffff',
    textAlign: 'center',
    textDecorationLine: 'underline',
    fontSize: 24,
  },
  overlayText: {
    fontFamily: 'Alegreya-Regular',
    color: '#ffffff',
    textAlign: 'left',
    fontSize: 16,
  },
  overlayPress: {
    borderWidth: 2,
    borderRadius: 6,
    padding: 2,
    marginTop: 20,
	fontSize: 20,
    fontFamily: 'Alegreya-Regular',
    color: '#ffffff',
    borderColor: '#ffffff',
    backgroundColor: '#000000',
    textAlign: 'center',
    alignSelf: 'center',
  },
  overlayImage: {
    height: 100,
    width: 100,
    alignSelf: 'center',
  },
  inventoryImage: {
    height: 25,
    width: 25,
    alignSelf: 'center',
  },
  overlayStyle: {
    borderWidth: 2,
    padding: 20,
    maxWidth: '98%',
    fontFamily: 'Alegreya-Regular',
    borderColor: '#ffffff',
    backgroundColor: '#000000'
  },
  overlayBack : {
    position: 'absolute',
    top: 0,
    left: 0,
    height: '100%',
    width: '100%',
    zIndex: -1,
  },
  schemeProgress: {
    position: 'absolute',
    backgroundColor: '#f44336',
    height: '100%',
  },
  row: {
    flexDirection: "row",
    height: '100%',
    alignItems: 'center',
    width: '100%',
  },
  lvlContainer: {
	backgroundColor: '#000000',
    justifyContent: 'center',
    alignContent: 'center',
  },
  lvlItem: {
    backgroundColor: '#fff',
    //borderTopWidth: 1,

    borderWidth: 2,
    borderColor: '#000',
    height: 38,
    width: '98%',
    flexDirection: 'row',
    alignContent: 'center',
    justifyContent: 'space-between',
    alignSelf: 'center',
  },
  lvlstart: {
    flexDirection: "row",
    height: '100%',
    alignItems: 'center',
  },
  lvlend: {
    flexDirection: "row",
    height: '100%',
    alignItems: 'center',
    alignSelf: 'flex-end',
  },
  lvltext: {
    fontFamily: 'Alegreya-Regular',
    color: '#000000',
    textAlign: 'left',
    fontSize: 20,
	paddingLeft: 5,
  },
  lvllogo: {
    margin: 5,
    alignContent: 'center',
    height: 25,
    width: 25,
  },
  location: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    borderBottomWidth: 2,
    borderColor: '#000000',
    backgroundColor: '#ffffff',
  },
  locationText: {
    flex: 1,
    color: '#000000',
    textAlign: 'center',
    fontSize: 20,
    fontFamily: 'Alegreya-Regular',
  },
   editAll: {
    position: 'absolute',
    left: 0,
	right: 0,
	top: 0,
	bottom: 0,
  },
});

export default HomeScreen;